<div class="generated-bill-container" *ngIf="billData">
  <!-- Page Header with Back Navigation -->
  <div class="page-header-section">
    <div class="back-navigation">
      <button mat-button (click)="onBack()" class="back-btn">
        <mat-icon>arrow_back</mat-icon>
        Back to Billing Management
      </button>
    </div>

    <div class="bill-header">
      <div class="header-left">
        <h1>Generated Bill</h1>
        <div class="bill-id">Bill #{{ billData.billId }}</div>
      </div>

      <div class="header-actions">
        <button
          mat-raised-button
          color="primary"
          (click)="printBill()"
          class="header-btn"
        >
          <mat-icon>print</mat-icon>
          Print Bill
        </button>
      </div>
    </div>
  </div>

  <!-- Print Container - This will be the only content printed -->
  <div class="print-container" #printContainer>
    <div class="bill-content">
      <!-- Invoice Header -->
      <div class="invoice-header">
        <div class="invoice-title">
          <h2>INVOICE</h2>
          <div class="invoice-details">
            <div class="bill-id">Bill #{{ billData.billId }}</div>
            <div class="bill-date">{{ formatDate(billData.generatedAt) }}</div>
          </div>
        </div>

        <div class="bill-to">
          <h3>Bill To:</h3>
          <div class="vendor-info">
            <div class="vendor-name">{{ vendorName }}</div>
            <div class="service-type">Transport Services</div>
          </div>
        </div>
      </div>

      <!-- Trip Details Table -->
      <div class="trip-details-section">
        <h3>Trip Details</h3>
        <div class="table-container">
          <table mat-table [dataSource]="billData.trips" class="trip-table">
            <!-- Route Name Column -->
            <ng-container matColumnDef="routeName">
              <th mat-header-cell *matHeaderCellDef>Route Name</th>
              <td mat-cell *matCellDef="let trip">
                {{ trip.routeName || "N/A" }}
              </td>
            </ng-container>

            <!-- Driver Column -->
            <ng-container matColumnDef="driver">
              <th mat-header-cell *matHeaderCellDef>Driver</th>
              <td mat-cell *matCellDef="let trip">
                {{ trip.driverDetails?.driverName || "N/A" }}
              </td>
            </ng-container>

            <!-- Date Column -->
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td mat-cell *matCellDef="let trip">
                {{ formatDate(trip.tripStartDate) }}
              </td>
            </ng-container>

            <!-- Distance Column -->
            <ng-container matColumnDef="distance">
              <th mat-header-cell *matHeaderCellDef>Distance</th>
              <td mat-cell *matCellDef="let trip">
                {{ trip.distance ? trip.distance + " km" : "N/A" }}
              </td>
            </ng-container>

            <!-- Rate Column -->
            <ng-container matColumnDef="rate">
              <th mat-header-cell *matHeaderCellDef>Rate</th>
              <td mat-cell *matCellDef="let trip">
                {{ trip.price ? "₹" + trip.price + "/km" : "N/A" }}
              </td>
            </ng-container>

            <!-- Amount Column -->
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef>Amount</th>
              <td mat-cell *matCellDef="let trip">
                {{ formatCurrency(trip.vehicleDetails?.cost || 0) }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>

      <!-- Cost Summary -->
      <div class="cost-summary-section">
        <div class="summary-item">
          <span class="label">Subtotal ({{ totalTrips }} trips):</span>
          <span class="value">{{ formatCurrency(billData.subtotal) }}</span>
        </div>

        <!-- Add-ons -->
        <div class="summary-item" *ngFor="let addon of billData.addons">
          <span class="label">{{ addon.name }}:</span>
          <span class="value">{{ formatCurrency(addon.amount) }}</span>
        </div>

        <!-- Discounts -->
        <div
          class="summary-item discount-item"
          *ngFor="let discount of billData.discounts"
        >
          <span class="label">{{ discount.name }}:</span>
          <span class="value discount-value"
            >-{{ formatCurrency(discount.amount) }}</span
          >
        </div>

        <div class="summary-item total-amount">
          <span class="label">Total Amount:</span>
          <span class="value">{{ formatCurrency(billData.totalAmount) }}</span>
        </div>
      </div>

      <!-- Payment Details -->
      <div class="payment-details-section">
        <h3>Payment Details</h3>
        <div class="payment-info">
          <div class="payment-item">
            <span class="label">Bank Name:</span>
            <span class="value">{{ bankDetails.bankName || "N/A" }}</span>
          </div>
          <div class="payment-item">
            <span class="label">IFSC Code:</span>
            <span class="value">{{ bankDetails.ifscCode || "N/A" }}</span>
          </div>
          <div class="payment-item">
            <span class="label">Account No:</span>
            <span class="value">{{ bankDetails.accountNumber || "N/A" }}</span>
          </div>
          <div class="payment-item">
            <span class="label">Account Holder:</span>
            <span class="value">{{
              bankDetails.accountHolderName || "N/A"
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
